import { createApiAction } from '@app/packages/api/utils'
import type { ApiAppStoreCustomerReview, ApiAppStoreCustomerReviewSummary } from '@app/packages/api/v2/types/entities'
import type { ApiAppStoreCustomerReviewRequest, ReviewsPageMeta } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getAppStoreCustomerReviewsByQuery = (request: ApiAppStoreCustomerReviewRequest) =>
  createApiAction('getAppStoreCustomerReviewsByQuery', dispatch =>
    dispatch<{ data: ApiAppStoreCustomerReview[]; meta: ReviewsPageMeta }>({
      method: 'GET',
      endpoint: v2Path('/api/v2/app_store_customer_reviews', request),
    })
  )

export const getAppStoreCustomerReviewsSummary = () =>
  createApiAction('getAppStoreCustomerReviewsSummary', dispatch =>
    dispatch<{ data: ApiAppStoreCustomerReviewSummary }>({ method: 'GET', endpoint: '/api/v2/app_store_customer_reviews/summary' })
  )
